export const billingsSources = {
  accrual: 'accrual',
  subtract: 'subtract'
}
